<template>
    <svg :height="height"
        :width="width"
        class="fill-current"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg">
        <path d="M8.59,16.59L13.17,12L8.59,7.41L10,6l6,6l-6,6L8.59,16.59z" />
        <path fill="none"
            d="M0,0h24v24H0V0z" />
    </svg>
</template>
<script>
    export default {
        props: {
            width: {
                type: String,
                default: '24'
            },
            height: {
                type: String,
                default: '24'
            }
        }
    }
</script>